import { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Spinner } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import Card from '../components/Card'
import API from '../api/api'

export default function Affiliate(props) {

    const user = useSelector(state => state.user)
    const [promoCodes, setPromoCodes] = useState()
    const [loading, setLoading] = useState(true)
    const [firstDay, setFirstDay] = useState(true)
    const [stripeLoading, setStripeLoading] = useState(false)

    useEffect(() => {
        _setUp()
    }, [])

    const _setUp = async () => {

        const date = new Date()
        setFirstDay(new Date(date.getFullYear(), date.getMonth(), 1));

        const res = await API.getAffiliate()
        console.log(res)
        setPromoCodes(res)
        setLoading(false)
    }

    const _addBank = async () => {
        setStripeLoading(true)
        const res = await API.setupBank()
        window.location.href = res.link.url

        setStripeLoading(false)

    }

    const _goToStripe = async () => {
        setStripeLoading(true)

        const res = await API.getStripeLink()
        window.location.href = res.link.url
        setStripeLoading(false)

    }

    return (
        <Container fluid className='pt-4 ps-4 m-0'>
            <h1 className='text-start'><b>Affiliate Portal</b></h1>
            <p className='text-start'>See Your Coupon's Performance</p>


            {loading && <div className='text-center my-1'><Spinner animation='border' /></div>}

            {!loading && <>

                <div className='text-start my-1'>
                    {!user?.connectId && <Button variant='primary' disabled={stripeLoading} onClick={_addBank}>Add Banking Details</Button>}
                    {user?.connectId && <Button variant='primary' disabled={stripeLoading} onClick={_goToStripe}>Go to Payouts</Button>}
                    {stripeLoading && <div className='text-center my-1'><Spinner animation='border' /></div>}

                </div>

                <p></p>
                {promoCodes?.map(code => <>
                    <Row>
                        {code?.promoCode && <Col md={6} className='mx-auto'>
                            <div className='border shadow bg-white rounded p-4'>
                                <h3 className='weight-bold'>Coupon</h3>
                                <p><b className='text-primary'>CODE: </b>{code?.promoCode.code}</p>
                                <p><b className='text-primary text-uppercase'>Subscription Discount: </b>-${(code?.promoCode.monthlyOff / 100).toFixed(2)} for {code?.promoCode.duration} Months </p>
                                <p><b className='text-primary text-uppercase'>Lifetime Discount: </b>-${(code?.promoCode.lifeTimeOff / 100).toFixed(2)}</p>
                                <hr />
                                <h3>Your Payout</h3>

                                <p><b className='text-primary'>Monthly Users: </b>${(code?.promoCode.monthlyPayout / 100).toFixed(2)}<small> / user</small> <em>(After 2 Months)</em></p>
                                <p><b className='text-primary'>Lifetime Purchase: </b>${(code?.promoCode.lifePayout / 100).toFixed(2)} <small> / user</small> </p>

                            </div>
                        </Col>}
                    </Row>
                    <Row className='mt-2'>
                        <Col className='p-2'>
                            <Card>
                                <p className='big-font text-primary'>{code?.promoCode?.uses || 0}</p>

                                <p className='lead weight-bold mt-4'>Total Uses </p>
                                <p><small>Since {new Date(code?.promoCode.createdAt).toLocaleDateString('en-US', { dateStyle: 'medium' })}</small></p>
                            </Card>
                        </Col>
                        <Col className='p-2'>
                            <Card>
                                <p className='big-font text-primary'>{code?.stats?.lifeTime || 0}</p>

                                <p className='lead weight-bold mt-4'>This Month's Lifetime Users</p>
                                <p><small>Since {new Date(firstDay).toLocaleDateString('en-US', { dateStyle: 'medium' })}</small></p>

                            </Card>
                        </Col>
                        <Col className='p-2'>
                            <Card>
                                <p className='big-font text-primary'>{code?.stats?.monthly || 0}</p>

                                <p className='lead weight-bold mt-4'>This Month's Monthly Users</p>
                                <p><small>Since {new Date(firstDay).toLocaleDateString('en-US', { dateStyle: 'medium' })}</small></p>

                            </Card>
                        </Col>
                    </Row>

                    <hr />
                </>)}
            </>}
        </Container>
    )
}